import { FC, useState, useEffect } from 'react';
import { useTrans } from 'base/utils/i18n';
import { ReferralTitle } from 'mod/referral/ReferralTitle';
import site from 'pro/config/site';
import { BtnSendReferral } from 'mod/referral/BtnSendReferral';

type IReferralInviteProps = {
    className?: string;
};

export const ReferralInvite: FC<IReferralInviteProps> = props => {
    const { className } = props;
    const { t } = useTrans();
    return (
        <div className={className}>
            <ReferralTitle>{t('web_referral_invite_friends', { brand: site.brand })}</ReferralTitle>

            <BtnSendReferral trackPosition={2}/>
        </div>
    )
};
